import Cookies from 'js-cookie';

export function patchFetchWithAuth() {
  const originalFetch = window.fetch;

  window.fetch = async (input, init = {}) => {
    const token = Cookies.get('token') || localStorage.getItem('token');

    // Ensure init exists
    init = init || {};

    const body = init.body;

    // Robust FormData detection
    const isFormData = body && typeof FormData !== 'undefined' && body instanceof FormData;

    const headers = {
      ...(init.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };

    // Only add JSON content-type if NOT FormData
    if (!isFormData) {
      headers['Content-Type'] = headers['Content-Type'] || 'application/json';
    }

    // Convert body to JSON only if NOT FormData and object
    const newBody = (!isFormData && body && typeof body === 'object') ? JSON.stringify(body) : body;

    const newInit = { ...init, headers, body: newBody };

    const response = await originalFetch(input, newInit);

    // Handle 401
    if (response.status === 401) {
      Cookies.remove('token');
      Cookies.remove('adminid');
      Cookies.remove('adminname');
      Cookies.remove('role');
      localStorage.removeItem('token');
      localStorage.removeItem('adminid');
      localStorage.removeItem('adminname');
      localStorage.removeItem('role');
      if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
        window.location.href = '/';
      }
    }

    return response;
  };
}
